import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../../../../src/constants';

export default StyleSheet.create({
  root: {
    flexDirection: 'row',
    paddingVertical: 6,
    display: 'block',
  },
  itemLeft: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    float: 'left',
  },
   itemRight: {
    display: 'inline-flex',
    alignItems: 'flex-end',
    marginRight: 12,
    float: 'right'
  },
  itemSeparator: {
    width: 1,
    backgroundColor: PALETTE.secondaryText,
    marginVertical: 8,
    marginHorizontal: 20,
  },
  itemLabel: {
    color: PALETTE.secondaryText,
  },
  itemValueBlank: {
    color: PALETTE.secondaryText,
  },
  marginValue: {
    marginTop: 10,
  },
});
